import React from 'react';
import { PermissionTypes } from '../../../../../../utils/constants/permissions';

export let priorityCells = [
  { className: 'user__name__cell', title: 'Name' },
  { className: 'notes__cell', title: 'Email' },
  { className: 'order__items__cell', title: 'Permissions' },
];

export function getCellContents(className, booking) {
  switch (className) {
    case 'user__name__cell':
      return (
        <span class="name__text">
          {booking.forename} {booking.surname}
        </span>
      );

    case 'notes__cell':
      return <span>{booking.email}</span>;
    case 'order__items__cell':
      if (booking.permissions && booking.permissions.length > 0) {
        return (
          <ul>
            {booking.permissions.map((root, index) => {
              const permission = Object.values(PermissionTypes).find(
                perm => perm.root === root
              );
              return (
                <li key={index}>{permission ? permission.title : root}</li>
              );
            })}
          </ul>
        );
      } else {
        return <span>No permissions</span>;
      }
    default:
      return '';
  }
}

export function shouldShowCell(cell, venue) {
  // const steps = getVenueSteps(venue);

  switch (cell.className) {
    case 'user__name__cell':
      return true;
    case 'notes__cell':
      return true;
    case 'order__items__cell':
      return true;
    default:
      return false;
  }
}

export function getCellLabel(className) {
  switch (className) {
    case 'user__name__cell':
      return 'Name';
    case 'contact__cell':
      return 'Email';
    case 'balance__due__cell':
      return 'Permission';
    case 'paid__at__cell':
      return 'Paid At';
    case 'party__details__cell':
      return 'Party Details';
    case 'reservations__cell':
      return 'Reservations';
    case 'order__cell':
      return 'Order';
    default:
      return '';
  }
}

export function formatOrderItems(booking, currencyMultiplier, currencyAccent) {
  const orderItems = Object.keys(booking.order_items || [])
    .map(index => {
      const orderItem = booking.order_items[index];
      if (!orderItem.children) {
        return 'Legacy Order';
      }

      const formattedItemPrice =
        orderItem.price > 0
          ? `at ${currencyAccent}${(
              orderItem.price / currencyMultiplier
            ).toFixed(2)}`
          : ``;
      const variants = orderItem.children || [];

      const drinkText = `<div class="${
        booking.live ? 'live' : 'preorder'
      } left__border left__border__accent"><span class="quantity__text">${
        orderItem.quantity
      } x</span> ${orderItem.name} ${
        !booking.live ? formattedItemPrice : ''
      } </div>`;

      const variantText = variants
        .map(variant => {
          if (variant.quantity === 0) {
            return '';
          }
          let formattedVariantPrice =
            variant.price > 0 && !booking.live
              ? `at ${currencyAccent}${(
                  variant.price / currencyMultiplier
                ).toFixed(2)}`
              : ``;

          return `<div class="${
            booking.live ? 'live' : 'preorder'
          } left__border left__border__primary left__border__offset-10"> ${
            variant.name
          } ${formattedVariantPrice} </div>`;
        })
        .join('');

      return drinkText + variantText;
    })
    .join('');

  const orderLine =
    orderItems === ''
      ? `<span class="no__order__text">No Order</span>`
      : orderItems;

  return orderLine;
}

var venueSteps = {
  id: '',
  hasBookingTime: false,
  hasReservations: false,
  hasPartyDetails: false,
};

export function getVenueSteps(venue) {
  if (!venue.steps) {
    return venueSteps;
  }

  if (venue.id !== venueSteps.id) {
    venueSteps.hasBookingTime = false;
    venueSteps.hasReservations = false;
    venueSteps.hasPartyDetails = false;

    venue.steps.forEach(step => {
      if (step.type === 'booking-datetime' && step.constraints.include_time) {
        venueSteps.hasBookingTime = true;
      }

      if (step.type === 'table') {
        //venueSteps.hasReservations = true
      }

      if (step.type === 'party-size') {
        //venueSteps.hasPartyDetails = true
      }
    });
  }

  return venueSteps;
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Users/ViewUsersPanel/TableCellGenerator/index.jsx